<template>
  <div class="personinfo-card">
    <div class="card-title">
      <div class="title-wrap">
        <span class="title">电子附件</span>
        <div class="icon"></div>
        <div class="tips">(附件要求：附件只支持上传图片，支持JPG、BMP、GIF、PNG、JPEG格式，大小不超过600K，若图片太大请自行处理后再上传)</div>
      </div>
      <div class="opt-right">
        <el-button @click="add" :disabled="isDisabled" type="primary" size="mini"><i
            class="el-icon-plus el-icon--left"></i>新增</el-button>
      </div>
    </div>

    <div class="card-body">

      <div class="body-item" v-for="(formData, index) in formDatas" v-bind:key="index">
        <el-form :inline="true" ref="formData" :model="formData" label-width="240px" :rules="rules"
          :disabled="isDisabled">
          <div class="body-item-tools">
            <i class="el-icon-delete delete" @click="removeData(formData.oid)" v-show="isShowItemDeleteBtn()"></i>
          </div>

          <div class="form_data ">
            <!-- <div class="img">
                <img  :src="avatarUploadPreview" alt="">
              </div> -->
            <div class="type">
              <el-form-item label="附件类型" prop="FileType" label-width="100px">
                <el-select class="typeselect" v-model="formData.FileType" placeholder="请选择附件类型">
                  <el-option label="荣誉证书" value="荣誉证书"></el-option>
                  <el-option label="其他" value="其他"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="other-info">
              <p class="name">文件名称: {{ formData.Name }}</p>
              <p class="filesize">大小: {{ formData.FileSize }}</p>
            </div>
            <div class="right-item">
              <div class="upload" v-show="isShowDownload(formData.oid)">
                <el-button type="primary" size="mini" @click="fileDownload(formData.Path, formData.Name)">下载<i
                    class="el-icon-download el-icon--right"></i></el-button>
              </div>
              <div class="download">
                <el-button type="primary" size="mini" :disabled="isDisabled" @click="fileUpload(formData.oid, index)">
                  上传<i class="el-icon-upload el-icon--right"></i></el-button>
                <input type="file" style="display:none;" ref="fileUploadData" @change="fileInputUpload" />
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { attachmentUpload, downfile } from '../request/api';
import avatarUploadPreview from '../../assets/attachment_placeholder.png';
import { Message } from 'element-ui'

export default {
  props: {
    VOStatus: {
      type: String,
      default: () => {
        return 'view'
      }
    },
    attchData: {
      type: Array,
      default: () => {
        return []
      }
    },
    formFlag: {
      type: Number,
      default: () => {
        return 1
      }
    },
    fileList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      avatarUploadPreview: avatarUploadPreview,
      // 用户填写信息
      formDatas: [],
      formDataNew: [],
      attchmentForm: {
        oid: 0,
        Name: '',
        FileType: '',
        FileSuffix: '',
        Path: '',
        FileSize: '',
        UploadOperator: '',
        UploadTime: ''
      },
      fileUploadSelect: {
        index: 0,
        oid: ''
      },
      currentLiStyle: 0,
      flag: true,
      familyFlag: false,
      addFlag: true,
      addFlag2: false,
      rules: {
        FileType: [
          { required: true, message: "请选择附件类型!", trigger: "blur" },
        ],
      },
    }
  },
  methods: {

    isShowItemDeleteBtn() {

      return this.isDisabled == false;
    },
    //新增成员
    add() {

      let newOid = new Date().getTime();
      this.formDataNew.push(newOid);

      this.formDatas.push({
        oid: newOid,
        Name: '',
        FileType: '',
        FileSuffix: '',
        Path: '',
        FileSize: '',
        UploadOperator: '',
        UploadTime: ''
      });

    },
    removeData(oid) {

      this.formDatas = this.formDatas.filter(item => oid != item.oid);
      this.formDataNew = this.formDataNew.filter(item => oid != item);

    },
    clearFormData() {
      // 重置数据
      this.formDatas = [];
      this.formDataNew = [];

    },
    resetFormData() {
      // 重置数据
      // if(!this.$refs.formData.length || this.$refs.formData.length == 0) {
      //       return;
      // }
      // for(let index in this.$refs.formData) {
      //       this.$refs.formData[index].resetFields();
      // }


    },
    formAllValidate() {
      // 表单验证
      return new Promise(function (resolve) {

        if(!this.$refs.formData 
          || !this.$refs.formData.length 
          || this.$refs.formData.length == 0) {
            resolve({
              "type": "attachmentCom",
              'status': 'ok',
              'msg': '没有数据,验证通过'
            });
        }

        var validateAll = [];
        for (let index in this.$refs.formData) {
          validateAll.push(this.$refs.formData[index].validate());
        }

        Promise.all(validateAll).then((values) => {

          let isHasImage = 0;
          for (let index in this.formDatas) {
            if (this.formDatas[index].FileType != null && this.formDatas[index].FileType.length > 0) {
              if (this.formDatas[index].Path == null || this.formDatas[index].Path == '') {
                isHasImage = 1;
                break;
              }
            }
          }
          if (isHasImage > 0) {
            resolve({
              "type": "attachmentCom",
              'status': 'fail',
              'msg': '请上传电子附件'
            });
            return;
          }
          resolve({
            "type": "attachmentCom",
            'status': 'ok',
            'msg': '验证通过'
          });
        }).catch((e) => {
          //console.log(e)
          resolve({
            "type": "attachmentCom",
            'status': 'fail',
            'msg': '请完善电子附件'
          });
        });

      }.bind(this));
    },
    formGetValue() {
      // 页面获取值
      return this.formDatas.map(item => {
        if (this.formDataNew.includes(item.oid)) {
          item.oid = 0;
        }
        return item;
      });
    },
    setFormDatas(datas) {
      // 设置数据
      this.formDataNew = [];
      // this.formDatas = datas;

      this.formDatas = datas.map(item => {

        var newItem = {};
        // rewardForm
        for (let k in this.attchmentForm) {
          if (item[k.toLowerCase()]) {
            newItem[k] = item[k.toLowerCase()].key;
          }
        }
        return newItem;
      });

    },
    //保存
    submit() {
      this.addFlag = !this.addFlag
      this.addFlag2 = !this.addFlag2
      this.familyFlag = !this.familyFlag
      this.flag = !this.flag
      this.assinList.push({
        name: { value: this.attchmentForm.name },
        filetype: { value: this.attchmentForm.filetype },
        filesuffix: { value: this.attchmentForm.filesuffix },
        path: { value: this.attchmentForm.path },
        filesize: { value: this.attchmentForm.filesize },
        uploadoperator: { value: this.attchmentForm.uploadoperator },
        uploadtime: { value: this.attchmentForm.uploadtime }
      })
      this.addNewList.push({
        name: this.attchmentForm.name,
        filetype: this.attchmentForm.filetype,
        filesuffix: this.attchmentForm.filesuffix,
        path: this.attchmentForm.path,
        filesize: this.attchmentForm.filesize,
        uploadoperator: this.attchmentForm.uploadoperator,
        uploadtime: this.attchmentForm.uploadtime
      })
      // this.$refs['attchmentForm'].resetFields()
    },
    //表单初始化
    initForm() {
      if (this.formFlag == 1) {
        this.familyFlag = false
      } else {
        this.addFlag = !this.addFlag
        this.addFlag2 = !this.addFlag2
        this.familyFlag = !this.familyFlag
        this.flag = !this.flag
      }
    },
    //列表选中框
    familyView(index) {
      // console.log(index)
      this.currentLiStyle = index
    },
    //  表单重置
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    fileInputUpload() {

      let oid = this.fileUploadSelect.oid || -1;
      let index = this.fileUploadSelect.index || 0;
      let file = this.$refs.fileUploadData[index];
      let filesize = file.files[0].size;
      let filetype = this.formDatas[index].FileType;

      if (filesize > 1 * 1024 * 600) {
        Message({
          type: 'warning',
          message: '上传附件不允许超过600k'
        });
        return;
      }

      var fileSuffix = file.value.substring(file.value.lastIndexOf('.')).toUpperCase();
      var suffix = [".JPG", ".BMP", ".GIF", ".PNG", ".JPEG"];
      if (!suffix.includes(fileSuffix)) {
        Message({
          type: 'warning',
          message: '附件只支持上传图片，支持JPG、BMP、GIF、PNG、JPEG格式'
        });
        return;
      }


      if (file) {
        attachmentUpload(file.files[0]).then((res) => {
          if (res.data && res.data.Name != -1) {
            Message({
              type: 'success',
              message: '上传文件成功!'
            });
          }else{
            if (res.data && res.data.Message) {
              this.$message.error(res.data.Message);
              return;
            }
          }
          this.formDatas = this.formDatas.map(item => {

            if (item.oid == oid) {
              item['Name'] = res.data['Name'];
              item['FileType'] = filetype;
              item['FileSuffix'] = res.data['Name'].substring(res.data['Name'].lastIndexOf('.'));
              item['Path'] = res.data['Path'];
              item['FileSize'] = filesize;
              item['UploadOperator'] = res.data['UploadOperator'];
              item['UploadTime'] = res.data['UploadTime'];
            }

            return item;
          });

        })
      }

    },
    // 是否显示下载按钮
    isShowDownload(oid) {
      let formData = this.formDatas.filter(item => item.oid == oid);
      if (formData && formData.length > 0) {
        return formData[0] && formData[0]['Path'] && formData[0]['Path'] != '';
      }
      return false;
    },
    fileUpload(oid, index) {

      this.fileUploadSelect = {
        oid,
        index
      }

      if (this.$refs.fileUploadData[index]) {
        this.$refs.fileUploadData[index].click();
      }

    },
    fileDownload(path, name) {
      if (path == '') {
        return;
      }
      var params = {
        "isWeb": "true",
        "isYES2": "true",
        "mode": "1",
        "service": "DownloadAttachment",
        "path": path,
        "formKey": "Announcement",
      };
      downfile(params).then((res) => {

        if (res) {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', name);
          document.body.appendChild(link);
          link.click();
        }

      });

    }
  },
  mounted() {
    // console.log(this.attchData);
    this.initForm()
  },
  computed: {
    isDisabled: function () {
      if (this.$props.VOStatus == 'view') {
        return true;
      } else if (this.$props.VOStatus == 'edit') {
        return false;
      } else if (this.$props.VOStatus == 'new') {
        return false;
      }
      return true;
    }

  }
}
</script>

<style lang="scss" scoped>
.personinfo-card {
  // line-height: 40px;
  width: 960px;
  margin-left: 14px;
  margin-right: 2px;

  .card-title {
    position: relative;
    // border-bottom: 1px solid #ebebeb;
    margin-bottom: 20px;

    .title-wrap {
      height: 40px;
    }

    .icon {
      height: 40px;
      width: 40px;
      background-image: url(../icons/icon/电子附件.png);
      background-position: center center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      float: left;
    }

    .title {
      line-height: 40px;
      font-size: 18px;
      font-weight: bold;
      color: #01539f;
      float: left;
    }

    .tips {
      color: red;
      font-size: 12px;
      position: absolute;
      bottom: 4px;
      left: 120px;
    }

    &::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: -12px;
      height: 1px;
      background: #ebebeb;
    }

    .opt-right {
      position: absolute;
      right: 12px;
      top: 0px;
      height: 40px;
      line-height: 40px;

      // .el-button {
      //   border: none;
      //   border-radius: 0px;
      // }
    }

  }


  .card-body {

    .body-item {
      border: 1px solid #eee;
      border-radius: 12px;
      padding: 12px;
      margin-bottom: 20px;
    }

    .body-item-tools {
      height: 30px;
      margin-bottom: 12px;

      .delete {
        float: right;
        margin-top: 6px;
        font-size: 18px;
        color: rgba(255, 0, 0, 0.85);
        cursor: pointer;
      }

      .delete:hover {
        color: rgba(255, 0, 0);
      }

      .delete:active {
        opacity: 0.5;
      }

    }

    .form_data {
      height: 80px;

      .type {
        float: left;
        height: 60px;
        width: 290px;
        padding: 0px;

        .typelabel {
          font-size: 12px;
          color: red;
          padding: 0px 5px;
        }

        .typeselect {
          width: 180px;
          padding: 0px 5px;
        }
      }

      .img {
        display: none;
        float: left;
        height: 80px;
        width: 80px;
        background: #eee;

        img {
          height: 100%;
          width: 100%;
        }

      }

      .other-info {
        float: left;
        height: 80px;
        width: 480px;

        .name {
          float: left;
          height: 80px;
          width: 340px;
          padding: 10px;
        }

        .filesize {
          padding: 10px 12px;
        }

      }

      .right-item {
        float: right;
        height: 80px;
        margin-left: 10px;

        .download {
          float: right;
          width: 80px;
          margin-top: 20px;

          .el-button {
            border: none;
            height: 30px;
            width: 75px;
            // margin-left: 10px;
            border-radius: 3px;
          }
        }

        .upload {
          width: 80px;
          // margin-top: 20px;
          // margin-right:20px;
        }

      }


    }

  }



}


::v-deep .el-textarea__inner {
  resize: none;
}
</style>
